// data
export const SET_LIVE_LINKS = 'SET_LIVE_LINKS';
export const SET_LIVE_LINKS_LOADING = 'SET_LIVE_LINKS_LOADING';
export const SET_LIVE_LINKS_ERROR = 'SET_LIVE_LINKS_ERROR';

// ui
export const SET_LIVE_LINK_FORM = 'SET_LIVE_LINK_FORM';
export const SET_LIVE_LINK_FORM_VALUE = 'SET_LIVE_LINK_FORM_VALUE';
export const SET_SHOW_LIVE_LINK_MODAL = 'SET_SHOW_LIVE_LINK_MODAL';
export const SET_SHOW_DELETE_CONFIRMATION = 'SET_SHOW_DELETE_CONFIRMATION';
export const SET_LIVE_LINK_SAVING = 'SET_LIVE_LINK_SAVING';
